export default __webpack_public_path__ + "static/media/code.5637c254.gif";